import { orderBy, take, uniqBy } from 'lodash';
import { useRef } from 'react';
import {
  RegisterAndSubscribeToMachineBindingDocument,
  RegisterAndSubscribeToMachineBindingSubscriptionResult,
  RegisterAndSubscribeToMachineBindingSubscriptionVariables,
} from '../graphql/generated';
import { useApolloSharedSubscription } from '../subscription/apollo-subscription.manager';
import { MachineLogMessage } from './binding/binding.types';

interface MonitorLogsConfig {
  disabled?: boolean;
}

const useMonitorLogs = (
  id?: string,
  limit?: number,
  config?: MonitorLogsConfig
): MachineLogMessage[] => {
  const bufferedLogs = useRef<MachineLogMessage[]>([]);

  const variables: RegisterAndSubscribeToMachineBindingSubscriptionVariables = {
    input: {
      machineId: id as string,
      binding: {
        namespace: 'machine',
        type: 'logs',
      },
    },
  };

  const { data } =
    useApolloSharedSubscription<RegisterAndSubscribeToMachineBindingSubscriptionResult>(
      {
        query: RegisterAndSubscribeToMachineBindingDocument,
        variables,
        subscriptionName: `binding-machine-logs-${id}`,
        resultBufferSize: 50,
        disabled: config?.disabled || id === undefined,
      }
    );

  const result = data?.registerAndSubscribeToMachineBindingResult;

  let messages: MachineLogMessage[] = [];
  if (result && result.data) {
    messages = result.data.messages || [];
  }
  const orderedLogs = orderBy(
    [...messages, ...bufferedLogs.current],
    ['timestamp'],
    ['desc']
  );

  const uniqueLogs = uniqBy(orderedLogs, 'messageId');

  bufferedLogs.current = take(uniqueLogs, limit ?? 1000);

  return bufferedLogs.current;
};

export { useMonitorLogs };
